import React from 'react';
const steps = [{
  num: '1',
  title: 'Elegís la edad del chico',
  desc: '(2–4 / 5–7 / 8–10 años)'
}, {
  num: '2',
  title: 'Elegís el objetivo',
  desc: '(lenguaje, atención, motricidad, emociones, diversidad)'
}, {
  num: '3',
  title: 'Imprimís (o plastificás)',
  desc: 'y aplicás en 10 a 15 minutos'
}, {
  num: '4',
  title: 'Usás las planillas',
  desc: 'para registrar el avance y saber qué viene después'
}];
export function CuadernillosDetail() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <div className="text-center mb-10 md:mb-16" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-6" data-id="element-64">
            Cómo funciona (en 4 pasos)
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-65">
            No es una carpeta enorme donde no sabés por dónde empezar. Es un
            sistema organizado para que uses exactamente lo que necesitás,
            cuando lo necesitás.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-66">
          {steps.map((step, i) => <div key={i} className="bg-brand-gray border-2 border-gray-100 p-6 md:p-8 rounded-2xl shadow-sm flex items-start gap-6" data-id="element-67">
              <div className="w-12 h-12 bg-brand-blue text-white rounded-full flex items-center justify-center text-2xl font-black flex-shrink-0" data-id="element-68">
                {step.num}
              </div>
              <div data-id="element-69">
                <h3 className="text-xl font-bold text-brand-dark mb-2" data-id="element-70">
                  Paso {step.num} → {step.title}
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-71">{step.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-green/10 border-2 border-brand-green p-6 md:p-8 rounded-2xl text-center max-w-3xl mx-auto" data-id="element-72">
          <p className="text-xl md:text-2xl font-bold text-brand-dark" data-id="element-73">
            <span className="text-brand-green" data-id="element-74">Resultado:</span> más claridad
            para vos, actividades más concretas para ellos, y menos
            improvisación en el día a día.
          </p>
        </div>
      </div>
    </section>;
}